import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Typography from '@material-ui/core/Typography'
import FileInput from '@team-griffin/react-file-input'
import Button from '@material-ui/core/Button'
import AddIcon from '@material-ui/icons/Add'

import List from '@material-ui/core/List'
import Attachment from './Attachment'
import AttachmentDialog from './AttachmentDialog'

import { handleUpdateAttachments } from '../actions/rfp'

import t from '../utils/lang'

const styles = theme => ({
  root: {
    minHeight: 'calc(100vh - 330px)',
    position: 'relative',
  },
  cardTitle: {
    fontSize: '1rem',
    fontWeight: 'bold'
  },
  addButton: {
    position: 'absolute',
    right: '15px',
    bottom: '15px'
  }
});

class Attachments extends Component {
	state = {
    attachments: [],
    openAttachmentDialog: false,
    attachmentData: {}
  }

  componentDidMount () {
    const { attachments } = this.props

    this.setState({
      attachments
    })
  }

  componentDidUpdate (prevProps) {
    const { attachments } = this.props

    if (this.state.attachments !== attachments) {
      this.setState({
        attachments: attachments
      })
    }
  }

  handleAttachmentDialogOpen = (event, attachmentId) => {
    const { attachments } = this.state
    const index = attachments.findIndex(attachment => attachment.id === attachmentId)
    const attachmentData = attachments[index]

    //console.log(attachmentData)

    this.setState({
      openAttachmentDialog: true,
      attachmentData
    })
  }

  handleAttachmentDialogClose = () => {
    this.setState({ openAttachmentDialog: false });
  }

  handleUpload = e => {
    const { dispatch, rfpId } = this.props
    const files = Array.from(e.target.files)

    const formData = new FormData()

    files.forEach((file, i) => {
      formData.append(i, file, file.name)
    })

    formData.append('rfpId', rfpId)

    dispatch(handleUpdateAttachments(formData))
  }

	render() {
    const { lang, classes, statusId } = this.props
    const { attachments, openAttachmentDialog, attachmentData } = this.state
    const proposalSubmitted = statusId === 3 ? true : false

		return (
      <Fragment>
        <Card className={classes.root}>
          <CardHeader title={`${attachments.length} ${t[lang].files}`} classes={{ title: classes.cardTitle }} />
          <CardContent>
            <List>
              {attachments.length !== 0 && attachments.map((attachment) => (
                <Attachment key={attachment.id} attachment={attachment} handleOpen={this.handleAttachmentDialogOpen} />
              ))}
            </List>
            {attachments.length === 0 && (<Typography variant="subheading">
              {t[lang].noAttachmentsInfo}
            </Typography>)}
          </CardContent>
          <CardActions>
            {!proposalSubmitted && (
              <FileInput
                id='uploadButton'
                //value={}
                multiple
                button={(
                  <Button
                    variant="fab"
                    color='secondary'
                    className={classes.addButton}
                    title={t[lang].addAttachment}
                  >
                    <AddIcon />
                  </Button>
                )}
                onChange={this.handleUpload}
              />)}
          </CardActions>
        </Card>

        <AttachmentDialog data={attachmentData} open={openAttachmentDialog} handleClose={this.handleAttachmentDialogClose} />
      </Fragment>
		)
	}
}

function mapStateToProps ({ rfpData, questions }) {
  const { id, statusId, attachments, lang } = rfpData

  return {
    rfpId: id,
    attachments: attachments ? Object.values(attachments) : [],
    statusId,
    lang
  }
}

export default connect(mapStateToProps)(withStyles(styles)(Attachments))


// WEBPACK FOOTER //
// ./src/components/Attachments.js